<template>
  <div v-if="hasPermission(permissions.expensesEdit)">
    <content-header>{{ $t('editExpense') }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <form class="forms-sample" @submit.prevent="onSubmit">
            <text-input id="title" :name="$t('title')" :validate="$v" :required="true" :max-length="true" :is-loading="isLoading" />
            <select-input
                id="expenseType"
                :name="$t('expenseType')"
                :validate="$v"
                :required="true"
                api-link="expenseTypes/GET_ALL"
                label="name"
                @itemSelected="e => form.expenseTypeId = e"
                :default-value="form.expenseTypeId"
                :is-loading="isLoading"
            />
            <select-input
                id="safeBox"
                :name="$t('safeBox')"
                :validate="$v"
                :required="true"
                api-link="safeBoxes/GET_ALL"
                label="name"
                @itemSelected="e => form.safeboxId = e"
                :default-value="form.safeboxId"
                :is-loading="isLoading"
            />
            <number-input id="mcPrice" :name="$t('price')" :validate="$v" :required="true" :is-loading="isLoading" />
            <number-input id="qty" :name="$t('qty')" :validate="$v" :required="true" :is-loading="isLoading" />
            <date-time-input id="date" :name="$t('date')" :default-value="getCurrentDate()" :validate="$v" :required="true" :is-loading="isLoading" />
            <text-area-input id="note" :name="$t('note')" :validate="$v" :is-loading="isLoading" />
            <file-input
                id="attachment"
                :name="$t('attachment')"
                @fileAdded="base64File => form.attachment = base64File"
            />
            <submit-input icon="fa-save" :name="$t('save')" :disabled="isLoading"/>
            <is-loading v-if="isLoading" />
          </form>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { required, maxLength } from 'vuelidate/lib/validators'
import IsLoading from "@/components/IsLoading";
import {Expense} from "@/models/Expense";
import SubmitInput from "@/components/Inputs/SubmitInput";
import FileInput from "@/components/Inputs/FileInput";
import SelectInput from "@/components/Inputs/SelectInput";
import TextInput from "@/components/Inputs/TextInput";
import NumberInput from "@/components/Inputs/NumberInput";
import DateTimeInput from "@/components/Inputs/DateTimeInput";
import TextAreaInput from "@/components/Inputs/TextAreaInput";
import {permissions} from "@/plugins/constants";

export default {
  name: "ExpenseEdit",
  components: {TextAreaInput, DateTimeInput, NumberInput, TextInput, SubmitInput, ContentHeader, 'v-content': Content, IsLoading, FileInput, SelectInput},
  data() {
    return {
      form: this.$helpers.convertArrayToObject(new Expense().fillAbles),
      isLoading: false,
      selectedItem: {},
      permissions: permissions
    };
  },
  mounted() {
    this.isLoading = true;
    this.$store.dispatch('expenses/GET_ONE', this.$route.params.id).then(async (response) => {
      this.form = await response.data;
      this.isLoading = false;
    }).catch(() => this.isLoading = false)
  },
  validations: {
    form: {
      title: {required, maxLength: maxLength(255)},
      expenseTypeId: {required},
      safeboxId: {required},
      mcPrice: {required},
      qty: {required},
      date: {required},
      note: {},
      attachment: {},
    }
  },
  methods: {
    onSubmit() {
      delete this.form.mcTotalPrice;
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error) return false;
      this.isLoading = true;
      this.$store.dispatch('expenses/UPDATE', {id: this.$route.params.id, form: this.form}).then(() => {
        this.$v.$reset();
        this.$router.push({name: "expenses"})
      }).catch(() => this.isLoading = false);
    }
  }
}
</script>
